import { render, staticRenderFns } from "./UiAccordion.vue?vue&type=template&id=3d52b655&scoped=true"
import script from "./UiAccordion.vue?vue&type=script&lang=js"
export * from "./UiAccordion.vue?vue&type=script&lang=js"
import style0 from "./UiAccordion.vue?vue&type=style&index=0&id=3d52b655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52b655",
  null
  
)

export default component.exports